import React, { useEffect } from 'react';
import Portfolio from './components/Portfolio';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css';
// Note: jQuery and Popper.js removed - not needed with React Bootstrap
import SEO from './components/SEO';
import useScrollReveal from './hooks/useScrollReveal';
import { startAnalyticsTracking } from './utils/analytics';

function App() {
  // Initialize scroll reveal animations
  useScrollReveal({
    threshold: 0.1,
    rootMargin: '0px 0px -80px 0px',
    once: true
  });

  useEffect(() => {
    const stopAnalytics = startAnalyticsTracking();
    return () => {
      stopAnalytics();
    };
  }, []);

  return (
    <>
      <SEO />
      <Portfolio />
    </>
  );
}

export default App;
